ui.autogrow('#autogrow-demo-1');
ui.autogrow('#autogrow-demo-2', {
	maxLines: 10
});
ui.autogrow('#autogrow-demo-3');



// WEBPACK FOOTER //
// ./src/components/autogrow/autogrow.demo.js